import { Schema as S } from "effect";

/**
 * Request schema for getting prescription detail
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const req: GetPrescriptionDetailRequest = { id: "abc123" }
 * ```
 */
export const GetPrescriptionDetailRequestSchema = S.Struct({
  id: S.String,
});

export type GetPrescriptionDetailRequest = S.Schema.Type<
  typeof GetPrescriptionDetailRequestSchema
>;
